module.exports = __webpack_public_path__ + "img/img13.fa15ef4f.svg";